var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAckodriveHotDeal = function SvgAckodriveHotDeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ackodrive-hotDeal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.383 25.5c1.989 0 3.896-.827 5.303-2.299s2.197-3.468 2.197-5.55c0-.906-.23-1.776-.5-2.585q-2.5 2.585-3.8 2.585c3.995-7.325 1.8-10.465-4.2-14.651.5 5.233-2.797 7.612-4.139 8.934a7.94 7.94 0 0 0-2.182 4.01 8.2 8.2 0 0 0 .349 4.6 7.8 7.8 0 0 0 2.757 3.6 7.27 7.27 0 0 0 4.215 1.356m.71-18.591c3.24 2.878 3.257 5.114.753 9.705-.762 1.395.202 3.13 1.737 3.13.688 0 1.384-.21 2.119-.622a5.85 5.85 0 0 1-1.186 2.326 5.5 5.5 0 0 1-2.053 1.53 5.28 5.28 0 0 1-4.893-.384 5.6 5.6 0 0 1-1.812-1.833 5.9 5.9 0 0 1-.84-2.486 6 6 0 0 1 .306-2.618 5.8 5.8 0 0 1 1.39-2.2c.126-.123.765-.716.793-.742.424-.398.773-.75 1.118-1.137 1.23-1.379 2.115-2.909 2.568-4.67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ackodrive-hotDeal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.383 0h30v30h-30z"
  })))));
};
export default SvgAckodriveHotDeal;